module.exports = __webpack_public_path__ + "static/media/GXP2130_large.5c3f3a9a.png";